import { makeStyles } from '@material-ui/core/styles'

export const layerPickerStyle = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.geoColors.contextBar.main,
    paddingBottom: 0,
    overflowX: 'hidden',
    overflowY: 'auto'
  },
  graphs: {
    maxHeight: 200
  },
  graphsDescription: {
    fontSize: '0.9rem',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  graphsButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  list: {
    paddingBottom: 0
  },
  groups: {
    width: '100%'
  },
  legendItems: {
    width: '100%',
    paddingTop: theme.spacing(2)
  },
  legendList: {
    paddingBottom: 0
  },
  button: {
    backgroundColor: theme.palette.primary.main
  },
  checkbox: {
    color: theme.palette.primary.main
  },
  listItemIcon: {
    minWidth: theme.spacing(4)
  },
  listTitle: {
    paddingRight: theme.spacing(2.5)
  },
  groupWithLayers: {
    borderTop: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.geoColors.contextBar.dark
  },
  groupWithSelectedLayer: {
    color: theme.palette.primary.main
  },
  nested: {
    paddingLeft: theme.spacing(3)
  },
  nestedListSubheader: {
    paddingRight: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.geoColors.headerText.main,
    userSelect: 'none'
  },
  nestedListSubheaderIcon: {
    float: 'left',
    paddingTop: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  collapseButton: {
    float: 'right',
    color: theme.palette.secondary.main
  },
  legend: {
    width: '100%'
  },
  triangle: {
    float: 'right',
    width: 0,
    height: 0,
    borderLeft: 10,
    borderLeftStyle: 'solid',
    borderLeftColor: 'transparent',
    borderRight: 10,
    borderRightStyle: 'solid',
    borderRightColor: 'transparent',
    borderBottom: 10,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.primary.main
  },
  firstTriangle: {
    marginTop: -theme.spacing(0.7),
    marginRight: theme.spacing(2)
  },
  secondTriangle: {
    marginTop: -theme.spacing(0.7),
    marginRight: theme.spacing(5.7)
  },
  thirdTriangle: {
    marginTop: -theme.spacing(0.7),
    marginRight: theme.spacing(9.7)
  },
  selectedLayerParams: {
    fontSize: '1.2rem'
  },
  selectedLayerParamsActive: {
    fontSize: '1.2rem',
    color: theme.palette.primary.main
  }
}))
